import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";
import mainSquare from "../../../logo.svg";
import ThemeSwitcher from "../../../components/ThemeSwitcher";

let serverConnection;
const petTypeOptions = [
  "狗狗",
  "貓咪",
  "兔兔",
  "鳥類",
  "鼠類",
  "爬蟲",
  "水族",
  "其他寵物",
];

const buildRoomSearch = (selfPetType, peerPetType) => {
  const roomSearch = new URLSearchParams();

  if (selfPetType) {
    roomSearch.set("selfPetType", selfPetType);
  }
  if (peerPetType) {
    roomSearch.set("peerPetType", peerPetType);
  }

  const queryString = roomSearch.toString();
  return queryString ? `?${queryString}` : "";
};

const Pool = () => {
  const [username, setUsername] = useState("");
  const searchParams = new URLSearchParams(window.location.search);
  const initialPetTypeFromQuery =
    searchParams.get("petType") || searchParams.get("dogBreed") || "";
  const [petType, setPetType] = useState(
    petTypeOptions.includes(initialPetTypeFromQuery)
      ? initialPetTypeFromQuery
      : petTypeOptions[0]
  );
  const history = useHistory();

  useEffect(() => {
    if (username) {
      const urlPath = `${window.location.pathname}?petType=${encodeURIComponent(
        petType
      )}`;
      serverConnection = new WebSocket(
        window.location.origin.includes("localhost")
          ? `wss://localhost:8443${urlPath}`
          : `wss://api.puipi.com${urlPath}`,
        [username]
      );
      serverConnection.onopen = () => {
        console.log("Websocket connected [pool]");
      };
      serverConnection.onmessage = ({ data }) => {
        const { roomId, selfPetType, peerPetType } = JSON.parse(data);
        serverConnection.close();
        history.push(
          `/video-chat/room/${roomId}${buildRoomSearch(selfPetType, peerPetType)}`
        );
      };
    }

    return () => {
      if (
        serverConnection &&
        (serverConnection.readyState === 0 || serverConnection.readyState === 1)
      ) {
        serverConnection.close();
      }
    };
  }, [history, petType, username]);

  const handleConfirm = () => {
    setUsername(Math.random().toString(36).slice(2));
  };

  const handleReturnHomePage = () => {
    history.push(`/`);
  };


  const handleCancelWaiting = () => {
    if (
      serverConnection &&
      (serverConnection.readyState === 0 || serverConnection.readyState === 1)
    ) {
      serverConnection.close();
    }
    setUsername("");
  };

  return (
    <div className={styles.container}>
      <header className={styles.topBar}>
        <div className={styles.headerBrand}>
          <div className={styles.brandTile}>
            <img src={mainSquare} alt="PuiPi Logo" className={styles.mainSquareImage} />
          </div>
          <div>
            <div className={styles.brandTitle}>PuiPi Pet Chat</div>
            <div className={styles.brandSubtitle}>寵物主人視訊配對</div>
          </div>
        </div>
        <div className={styles.topActions}>
          <ThemeSwitcher />
          <button
            type="button"
            className={styles.returnHomePageBtn}
            onClick={handleReturnHomePage}
          >
            返回首頁
          </button>
        </div>
      </header>
      {username ? (
        <div className={styles.waitingCard}>
          <div className={styles.waitingTitle}>正在為你隨機配對視訊夥伴</div>
          <div className={styles.waitingText} role="status" aria-live="polite">
            已記錄你的寵物類型偏好：{petType}（僅用於聊天開場，不影響配對）
          </div>
          <button
            type="button"
            className={styles.leaveBtn}
            onClick={() => {
              handleCancelWaiting();
            }}
          >
            取消等待
          </button>
        </div>
      ) : (
        <>
          <div className={styles.heroCard}>
            <h1 className={styles.title}>寵物主人視訊配對</h1>
            <p className={styles.subtitle}>
              和其他飼主即時聊毛孩日常，配對完全隨機，輕鬆開聊。
            </p>
            <div className={styles.selectBlock}>
              <label className={styles.selectLabel} htmlFor="pet-type">
                你的寵物類型：
              </label>
              <select
                id="pet-type"
                className={styles.selectRound}
                value={petType}
                onChange={(e) => setPetType(e.target.value)}
              >
                {petTypeOptions.map((type) => (
                  <option value={type} key={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            <div className={styles.randomHint}>配對規則：不分寵物類型，系統隨機安排</div>
          </div>

          <button type="button" className={styles.enterRoomBtn} onClick={handleConfirm}>
            開始視訊配對
          </button>
        </>
      )}
    </div>
  );
};

export default Pool;
